import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
const transformations = [{
  before: 'https://cdn.magicpatterns.com/uploads/rG55NMtCzYNqixeiMAXR8F/Screenshot_2026-06-08_at_1.13.57_PM.png',
  after: 'https://cdn.magicpatterns.com/uploads/oEUf9sijiBDbjCZFoFcPQ8/Screenshot_2026-06-08_at_1.14.06_PM.png',
  title: 'Restored Curls & Confidence',
  description: 'From thinning edges to a full, soft curly style — a complete glow-up that brings back volume, shine, and confidence.'
}];
export function BeforeAfter() {
  return <section className="py-24 bg-brand-light relative overflow-hidden" data-id="element-29">
      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-30">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-31">
          <div className="flex items-center justify-center gap-2 mb-3 text-brand-purple" data-id="element-32">
            <Sparkles className="w-4 h-4 text-brand-gold" data-id="element-33" />
            <h2 className="font-semibold tracking-widest uppercase text-sm" data-id="element-34">
              Transformations
            </h2>
            <Sparkles className="w-4 h-4 text-brand-gold" data-id="element-35" />
          </div>
          <h3 className="text-4xl md:text-5xl font-serif text-brand-dark mb-6" data-id="element-36">
            Before &amp; After
          </h3>
          <p className="text-gray-600 font-light text-lg" data-id="element-37">
            See the magic for yourself. Real results from Shazz's chair, where
            every transformation tells a story of renewed confidence.
          </p>
        </div>

        <div className="max-w-5xl mx-auto space-y-16" data-id="element-38">
          {transformations.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.7
        }} data-id="element-39">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 items-center relative" data-id="element-40">
                {/* Before */}
                <figure className="relative" data-id="element-41">
                  <div className="aspect-[4/5] overflow-hidden bg-white shadow-lg" data-id="element-42">
                    <img src={item.before} alt={`Before: ${item.title}`} loading="lazy" className="w-full h-full object-cover" data-id="element-43" />
                  </div>
                  <figcaption className="absolute top-4 left-4 bg-brand-dark/80 text-white text-xs font-semibold uppercase tracking-widest px-4 py-2" data-id="element-44">
                    Before
                  </figcaption>
                </figure>

                {/* Arrow connector */}
                <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-20 w-14 h-14 bg-brand-purple text-brand-gold rounded-full items-center justify-center shadow-xl" data-id="element-45">
                  <ArrowRight className="w-6 h-6" data-id="element-46" />
                </div>

                {/* After */}
                <figure className="relative" data-id="element-47">
                  <div className="aspect-[4/5] overflow-hidden bg-white shadow-2xl ring-2 ring-brand-gold/40" data-id="element-48">
                    <img src={item.after} alt={`After: ${item.title}`} loading="lazy" className="w-full h-full object-cover" data-id="element-49" />
                  </div>
                  <figcaption className="absolute top-4 left-4 bg-brand-purple text-white text-xs font-semibold uppercase tracking-widest px-4 py-2" data-id="element-50">
                    After
                  </figcaption>
                </figure>
              </div>

              <div className="text-center mt-8 max-w-2xl mx-auto" data-id="element-51">
                <h4 className="text-2xl font-serif text-brand-dark mb-2" data-id="element-52">
                  {item.title}
                </h4>
                <p className="text-gray-600 font-light" data-id="element-53">{item.description}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}